@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.summary-header {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.premium-programs {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.summary-extra-info {
  font-size: 14px;
  color: @orders-drawer--default--text-color;
  font-weight: 100;
  padding-top: 1px;
  align-items: center;
}
.summmary-message {
  display: inline-block;
  padding: 15px 30px;
  font-size: 13px;
}
